import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReviewFileUserStatusColorPipe } from './review-file-user-status-color.pipe';

@NgModule({
  declarations: [ReviewFileUserStatusColorPipe],
  imports: [CommonModule],
  exports: [ReviewFileUserStatusColorPipe],
  providers: [ReviewFileUserStatusColorPipe]
})
export class ReviewFileUserStatusColorModule { }
